import React, { useState } from "react";
import { connect } from "react-redux";
import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonTextarea,
  IonItem,
  IonLabel,
  IonNote,
} from "@ionic/react";

import { loadDebugState } from "services/debug";

export interface Props {
  loadDebugState: Function;
}

interface validation {
  [key: string]: boolean | undefined;
}

const LoadState: React.FC<Props> = ({ loadDebugState }) => {
  const [isTouched, setIsTouched] = useState<validation>({});
  const [isValid, setIsValid] = useState<validation>({});
  const [newState, setNewState] = useState<any>("");

  const validateInput = (field: string, value: string) => {
    setIsValid({ ...isValid, [field]: undefined });

    // if (value === "") return;

    if (field === "name") {
      if (value === "") setIsValid({ ...isValid, name: false });
      else setIsValid({ ...isValid, name: true });
    }
  };

  const markTouched = (e: any) => {
    let field = e.target.name;
    setIsTouched({ ...isTouched, [field]: true });
  };

  const onChange = (e: any) => {
    let value = e.target.value;
    let field = e.target.name;
    validateInput(field, value);
    setNewState(value);
  };

  const submit = () => {
    loadDebugState(newState);
  };

  return (
    <IonCard>
      <IonCardHeader>
        <IonCardTitle>Load App State</IonCardTitle>
        <IonCardSubtitle>
          Load an app state into the app. This will overwrite the current app
          state so that we can debug issues.
        </IonCardSubtitle>
      </IonCardHeader>
      <IonCardContent>
        <IonItem
          className={`${isValid.newState && "ion-valid"} ${
            isValid.newState === false && "ion-invalid"
          } ${isTouched.newState && "ion-touched"}`}
        >
          <IonLabel position="floating">State to Load</IonLabel>
          <IonTextarea
            name="newState"
            placeholder="State to load"
            value={newState}
            onIonChange={onChange}
            onIonBlur={markTouched}
          />
          <IonNote slot="helper">Enter the state to load</IonNote>
          <IonNote slot="error">Invalid state</IonNote>
        </IonItem>

        <IonButton color="primary" onClick={submit}>
          Load State
        </IonButton>
      </IonCardContent>
    </IonCard>
  );
};

const mapStateToProps = (state: any) => ({
  debug: state,
  user: state.user,
  quizData: state.quiz,
  teams: state.teams.teams,
  ccConnected: state.general.ccConnected,
});

export default connect(mapStateToProps, { loadDebugState })(LoadState);
